<template>
    <!--<div class="w-full">
        <form class="my-2 mx-4 border border-gray-300 bg-gray-100">
            <h2 class="text-green-600 text-2xl leading-10 pr-8 ml-8 mt-8 text-left">Module record {{ itemIndex + 1}} <span v-if="itemIndex === 0"> - most recent</span></h2>
            <div class="flex flex-wrap p-3 w-full justify-center" @change="dirtyForm()" @keydown="dirtyForm">
                <text-input v-model="form.moduleName" class="" label="Module Name and Code" @blur="updateModuleDetails($event)"/>
                <text-input v-model="form.grade" class="" label="Grade (if available)" @blur="updateModuleDetails($event)"/>
            </div>
            <div class="items-center">
                <div v-if="successMessage" class="mx-8 success-message">{{ successMessage }}</div>

                <div v-if="Object.keys(validationErrors).length > 0">
                    <p class="server-error mx-8">There were some validation issues, please check the fields above</p>
                </div>
                <div class="flex flex-wrap justify-center">
                    <button class="w-3/4 sm:w-52 mt-0 sm:mt-8 my-8 sm:ml-4 bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded" type="button" @click="removeRecord">
                        Remove this record
                    </button>
                </div>
            </div>
        </form>
    </div>-->
    <tr>
        <td class="px-4 py-2 border border-gray-300">
        <input type="text" v-model="moduleData.moduleName" @input="updateModule" class="form-input w-full" />
        </td>
        <td class="px-4 py-2 border border-gray-300">
        <input type="text" v-model="moduleData.grade" @input="updateModule" class="form-input w-full" />
        </td>
        <td class="px-4 py-2 border border-gray-300">
        <button @click="removeRecord" class="btn btn-danger">Delete</button>
        </td>
    </tr>
</template>

<script>
import TextInput from '@/shared/TextInput'
import SelectInput from '@/shared/SelectInput'
import ApplicationComponentSaveButton from '@/shared/ApplicationComponentSaveButton'
import TextareaInput from '@/shared/TextareaInput'

export default {
    components: {
        ApplicationComponentSaveButton,
        TextInput,
        SelectInput,
        TextareaInput,
    },
    props: {
        itemIndex: Number,
        moduleData: {
            type: Object,
            default: function () {
                return {
                    index: null,
                }
            },
        },
    },
    data() {
        return {
            form: {
                moduleName: this.moduleData.moduleName,
                grade: this.moduleData.grade,
                errors: {},
            },
            formDirty: false,
            loading: false,
            successMessage: '',
            serverErrors: '',
        }
    },
    computed: {
        validationErrors: {
            get: function() {
                return this.form.errors
            },
            set: function(newValue) {
                for (const key in newValue)
                {
                    this.form.errors[key] = newValue[key].join(' ')
                }
            },
        },

    },
    methods: {
        removeRecord() {
            if(confirm('Are you sure you want to remove this module record?'))
            {
                this.$emit('delete', this.itemIndex)
            }

        },
        updateModuleDetails() {
            this.$emit('update-module', {    
            moduleName: this.form.moduleName,
            grade: this.form.grade,
            index: this.itemIndex
            });
        },

        dirtyForm() {
            this.formDirty = true
            this.successMessage = ''
        },
    },
}
</script>